"use client";

import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("Global error:", error);
  }, [error]);

  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        }}
      >
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "2rem",
            background:
              "linear-gradient(135deg, #ffffff 0%, #f5f3ff 50%, #eff6ff 100%)",
            textAlign: "center",
          }}
        >
          <div
            style={{
              width: "80px",
              height: "80px",
              borderRadius: "50%",
              background: "rgba(82, 49, 231, 0.1)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: "2rem",
            }}
          >
            <svg
              width="40"
              height="40"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#5231E7"
              strokeWidth="1.5"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
              />
            </svg>
          </div>

          <h1
            style={{
              fontSize: "1.875rem",
              fontWeight: 700,
              color: "#111827",
              marginBottom: "1rem",
            }}
          >
            Something went wrong
          </h1>

          <p
            style={{
              fontSize: "1.125rem",
              color: "#4B5563",
              maxWidth: "28rem",
              lineHeight: 1.6,
              marginBottom: "2rem",
            }}
          >
            We hit a temporary snag loading this page. A quick refresh usually
            fixes it.
          </p>

          <div
            style={{
              display: "flex",
              gap: "1rem",
              flexWrap: "wrap",
              justifyContent: "center",
            }}
          >
            <button
              onClick={reset}
              style={{
                background: "#5231E7",
                color: "white",
                border: "none",
                borderRadius: "9999px",
                padding: "0.625rem 1.5rem",
                fontSize: "1rem",
                fontWeight: 500,
                cursor: "pointer",
              }}
            >
              Try Again
            </button>

            <a
              href="/"
              style={{
                background: "white",
                color: "#5231E7",
                border: "1px solid #5231E7",
                borderRadius: "9999px",
                padding: "0.625rem 1.5rem",
                fontSize: "1rem",
                fontWeight: 500,
                textDecoration: "none",
                display: "inline-block",
              }}
            >
              Go Home
            </a>
          </div>
        </div>
      </body>
    </html>
  );
}
